var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-4 mb-4"},[_c('h4',{staticClass:"pb-1 mt-1 mb-4"},[_vm._v("Manuale d'uso")]),_c('b-row',[_c('b-col',[_c('h5',[_c('a',{staticClass:"text-secondary point",attrs:{"href":_vm.manualeUrl,"target":"_blank"}},[_c('u',[_vm._v("Scarica la versione aggiornata")])])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }